import React from "react";
import Collapse from "../../components/Collapse";
import athena from "../../assets/images/athena_logo.png";
import usds from "../../assets/images/usds_logo.png";
import usds2 from "../../assets/images/usds_logo_text_2.png";
import glytec from "../../assets/images/glytec_logo.png";
import twoU from "../../assets/images/2U_logo.png";
import cka from "../../assets/images/cka.png";
import usc from "../../assets/images/usc_logo.png";
import harvard from "../../assets/images/harvard_logo.png";
import scheck from "../../assets/images/scheck_logo.png";
import denver from "../../assets/images/codefordenver_logo.png";
import blackduck from "../../assets/images/blackduck_logo.png";

const FullCV = () => {
  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12">
          <h1 className="text-center">Full Resume / Curriculum Vitae (CV)</h1>
          <p className="text-center">Click on the tabs below for details.</p>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-sm-12 col-md-12">
          <div className="justify-content-center">
            <div
              className="accordion"
              id="accordionExample"
              style={{ maxWidth: "75vw" }}
            >
                           <Collapse
                image={<img src={blackduck} alt="Black Duck" className="imgStyle" />}
                idNum={"bd"}
              >
                <strong>Senior Application Security Engineer</strong>
                <p>
                  <i>November 2025 - Present</i>
                </p>
     <li>Own platform deployment and codebase integration for enterprise DevSecOps applications involving cloud installation, container orchestration, CI/CD pipeline instrumentation, system administration, integrated IAM/SSO, compiler invocation tracing, package manager analysis, developer team rollout, automated vulnerability JIRA ticketing, network security troubleshooting, AppSec policy design, and SBOM reporting as well as microservice and embedded OS vulnerability remediation management.
</li><li>Operationalize enterprise-scale vulnerability investigation, CVSS vector scoring analysis, CVE submodule mapping, risk triage, remediation workflows, status reporting, alert automation and policy management.
</li><li>Perform threat analysis to regulatory non-compliance and IAM authorization risks.
</li><li>Build Python and Bash scripting solutions for at-risk SCA scanning limitations.
</li><li>Deploy and troubleshoot Kubernetes and Docker Swarm installations, resolving issues such as ingress routing rules, helm commands, container settings, Postgres extensions, sizing, compatibility, service communications, certificates, load balancer settings and environment secret misconfigurations.
</li><li>Lead Docker Swarm to AKS application platform migrations involving database export, stage testing, configuration analysis, maintenance window planning and Go-Live cutover coordination.
</li><li>Troubleshoot AWS VPC, subnet, endpoint security policies, DNS, DPI and gateway networking for on-prem customer installations.
</li><li>Solution architect product configuration strategies by conducting versioning, submodule and release engineering analysis.
</li><li>Lead an iterative working group model for security consulting SOP control and runbooks maintenance delivered by AppSec field engineers.
</li><li>Configured and deployed AWS-based FinOps monitoring and optimization solutions across a global team resulting in projected cost savings of 2k+ per year.
</li>
              </Collapse>
                           <Collapse
                image={<img src={cka} alt="CKA" className="imgStyle" />}
                idNum={"cka"}
              >
                <strong>Certified Kubernetes Administrator</strong>
                <p>
                  <i>July 2025</i>
                </p>
                <li>
                  Managed and troubleshot Kubernetes clusters, demonstrating fluency across key stores, node and pod networking, RBAC configuration, log analysis, Helm and workload scheduling under real-time constraints for the Certified Kubernetes Administrator exam.
                  </li>
              </Collapse>
              <Collapse
                image={<img src={twoU} alt="2U" className="imgStyle" />}
                idNum={"2u"}
              >
                <strong>Full Stack Security Specialist</strong>
                <p>
                  <i>March 2020 - August 2024</i>
                </p>
     <li>Provided technical support for cybersecurity applications, full-stack codebases and cloud infrastructure across 100+ partner education programs, earning 4.9/5 CSAT score.
</li><li>Diagnosed and resolved 1000+ system misconfigurations and programming errors across Azure, React, Node, npm, SQL, Docker, Linux, Bash, Splunk, Wireshark, Burp Suite, Metasploit, Git, REST and GraphQL through live debugging sessions.
</li><li>Performed code reviews, API endpoint automated testing, user acceptance testing, quality assessments and system command/configuration verification for 4000+ student deliverables within timed and audited ticketing workflows.
</li><li>Provided technical guidance for project feature enhancements, package integrations, dependency management, product presentations, cybersecurity forensic reports, pentesting simulations, system diagrams, SIEM log analyses and packet captures.
</li>
              </Collapse>
              <Collapse
                image={
                  <img
                    src={denver}
                    alt="Code For America (Denver)"
                    className="imgStyle"
                  />
                }
                idNum={"america"}
              >
                <strong>Developer</strong>
                <p>
                  <i>December 2020 - March 2021</i>
                </p>
                <li>
                Built a survey-based screening tool prototype for Expunge Colorado in collaboration with a team of four professional developers using tools such as AWS DynamoDB, AWS API Gateway, React.js, contentful, serverless and Survey.js.
                </li>
              </Collapse>
              <Collapse
                image={
                  <img
                    src={harvard}
                    alt="Harvard University"
                    className="imgStyle"
                  />
                }
                idNum={"harvard"}
              >
                <strong>Harvard Extension School - Full-Stack Coding Bootcamp</strong>
                <p>
                  <i>March 2019 - September 2019</i>
                </p>
                <li>
                  Completed a six-month full-stack coding bootcamp implementing
                  web development tools and practices such as VS Code, GitHub,
                  Postman, React, MySQL and MongoDB as well as version control
                  and code reviews for both independent and team-based projects.
                </li>
              </Collapse>
              {/* <Collapse
                image={<img src={glytec} alt="Glytec" className="imgStyle" />}
                idNum={"glytec"}
              >
                <strong>Solution Architect</strong>
                <p>
                  <i>March 2019 - September 2019</i>
                </p>
                <li>
                  Project managed the technical delivery of five (5) hospital
                  implementations for interface types such as ADFS SSO, SMART on
                  FHIR, ADT, and ORU through collaboration with clinical,
                  engineering, networking and business teams.
                </li>
              </Collapse> */}
              <Collapse
                image={
                  <img src={athena} alt="athenahealth" className="imgStyle" />
                }
                idNum={"athena"}
              >
                <strong>Application Integration Engineer</strong>
                <p>
                  <i>June 2016 - March 2019</i>
                </p>
     <li>Automated data processing by configuring, testing and deploying to Production 150+ application integrations, implementing security protocols, user IAM, data pipelines, batch processing, event-driven triggers, troubleshooting ingress/egress traffic and managing Go-Live and post-deployment monitoring.
</li><li>Led real-time incident response for 40+ escalated integration connectivity disruptions impacting Go-Live-critical enterprise projects, resolving data transmission failures, backlogged message queues and data pipeline misconfigurations through root cause analysis, policy revisions, scalability review, R&D collaboration, product enhancements and performance analysis.
</li><li>Secured sensitive patient and financial data integrations by configuring and troubleshooting encryption, authentication and availability involving SAML 2.0, HTTP/S, mTLS, IPSec, packet captures, cron jobs, firewalls and network settings.
</li><li>Managed the project delivery SOPs of a team of 7 Integration Analysts through process creation, feedback cycles, escalation management, technical mentorship, training and integration engine documentation.
</li><li>Addressed integration tooling, process and documentation gaps by implementing a mixed methods Scrum & Kanban business framework in JIRA resulting in the completion of 115 user stories executed across 18 sprints.
</li>                <br />
              </Collapse>
              <Collapse
                image={
                  <img
                    src={usds}
                    alt="US Department of State"
                    className="imgStyle"
                  />
                }
                imageTwo={
                  <img
                    src={usds2}
                    alt="US Department of State"
                    className="imgStyle"
                  />
                }
                idNum={"usds"}
              >
                <strong>IE University Fulbright Assistant</strong>
                <p>
                  <i>August 2014 - December 2015</i>
                </p>

     <li>Project managed the formalization of the IE University language department’s registration processes, internal policies, testing tools, reporting metrics and interdepartmental workflows by collaborating with administrative, engineering and instructional staff to manage over 1500 students.
</li><li>Led the full implementation of new test score scaling tools through vendor assessments, sample testing, workflow training.
</li><li>Strengthened operational resilience by consolidating disparate cross-departmental data into interactive workbooks for leadership reporting on budget distribution, growth trends, and placement algorithms.
</li>
              </Collapse>
              <Collapse
                image={
                  <img
                    src={usc}
                    alt="University of Southern California"
                    className="imgStyle"
                  />
                }
                idNum={"usc"}
              >
                <strong>Pullias Research Assistant</strong>
                <p>
                  <i>May 2011 - March 2012</i>
                </p>
                <li>
                  Catalogued 23 research studies by reviewing and summarizing
                  details such as the literature review theoretical framework,
                  sample, methods, hypothesis, and results.
                </li>
                <li>
                  Created visualizations of math policy structures and
                  standardized test policies for the LACCD school district.
                </li>
                <br />
                <strong>McNair Research Fellow</strong>
                <p>
                  <i>January 2010 - August 2010</i>
                </p>
                <li>
                  Conducted a comparative cost-benefit study of economic policy
                  responses to recessions in Peru and Colombia.
                </li>
              </Collapse>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FullCV;
